var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSmileyNervous = function SvgIconSmileyNervous(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.781 13.625a1 1 0 0 0-1.563.002l-.956 1.2a1 1 0 0 0 1.564 1.246l.176-.22.717.897a1 1 0 0 0 1.562 0l.72-.9.718.9a1 1 0 0 0 1.562 0l.718-.897.175.22a1 1 0 0 0 1.564-1.246l-.956-1.2a1 1 0 0 0-1.563-.002l-.719.9-.719-.9a1 1 0 0 0-1.562 0l-.719.9zM8.625 11.625a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16.875 10.125a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0",
    clipRule: "evenodd"
  }))));
};
export default SvgIconSmileyNervous;